export enum NotificationTypeEnum {
    NOTIFICATION = 0,
    SYSTEM_NOTIFICATION
}